import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plus, Trash2, Train as TrainIcon } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '../../components/ui/dialog';
import { toast } from '../../hooks/use-toast';

import { API } from '../../config';

const AdminTrains = () => {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ number: '', name: '', from: '', to: '', departure: '', arrival: '', duration: '' });

  const t = () => localStorage.getItem('tp_admin_token');
  const load = async () => {
    const r = await axios.get(`${API}/admin/trains`, { headers: { Authorization: `Bearer ${t()}` } });
    setList(r.data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.number || !form.name) { toast({ title: 'Number and name required' }); return; }
    await axios.post(`${API}/admin/trains`, form, { headers: { Authorization: `Bearer ${t()}` } });
    setOpen(false); setForm({ number: '', name: '', from: '', to: '', departure: '', arrival: '', duration: '' });
    load();
  };
  const del = async (id) => {
    if (!window.confirm('Delete this train?')) return;
    await axios.delete(`${API}/admin/trains/${id}`, { headers: { Authorization: `Bearer ${t()}` } });
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold text-[#0B2E5C]">Manage Trains</h1>
          <p className="text-sm text-gray-500">{list.length} trains in the system</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-tp-orange hover:bg-[#E07A0F] text-white font-semibold"><Plus size={16} className="mr-1" /> Add Train</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Add Train</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3">
              {['number','name','from','to','departure','arrival','duration'].map(k => (
                <div key={k}><label className="text-xs font-semibold uppercase text-gray-500">{k}</label>
                  <Input value={form[k]} onChange={e=>setForm({...form, [k]: e.target.value})} />
                </div>
              ))}
            </div>
            <DialogFooter>
              <Button onClick={add} className="bg-tp-orange hover:bg-[#E07A0F] text-white">Save</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr><th className="text-left py-3 px-4">Train</th><th className="text-left py-3 px-4">Route</th><th className="text-left py-3 px-4">Timings</th><th className="text-left py-3 px-4">Duration</th><th className="py-3 px-4"></th></tr>
          </thead>
          <tbody>
            {list.map(tr => (
              <tr key={tr.id} className="border-t">
                <td className="py-3 px-4"><div className="flex items-center gap-2"><TrainIcon size={14} className="text-tp-orange" /><div><div className="font-mono font-bold">{tr.number}</div><div className="text-xs text-gray-500">{tr.name}</div></div></div></td>
                <td className="py-3 px-4">{tr.from} → {tr.to}</td>
                <td className="py-3 px-4">{tr.departure} - {tr.arrival}</td>
                <td className="py-3 px-4">{tr.duration}</td>
                <td className="py-3 px-4 text-right"><button onClick={()=>del(tr.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="text-center py-10 text-gray-400">No trains yet</div>}
      </div>
    </div>
  );
};

export default AdminTrains;
